import { AppThunk } from "@/redux/RootReducer";
import { batch } from "react-redux";
import { expectedVolumeActions } from "../ExpectedVolumeRedux";

export const expectedVolumeTableReset =
  (): AppThunk => async (dispatch, getState) => {
    const state = getState().expectedVolume;

    const routeIds = Object.keys(state.expectedVolumesByRoutePair);
    batch(() =>
      routeIds.forEach((routeId) =>
        dispatch(expectedVolumeActions.revertAllRowsToPersistedState(routeId))
      )
    );
  };
